import { createContext, useState, useContext, ReactNode, PropsWithChildren } from 'react';
// Define types
interface LocalizationContextType {
    language: string;
    toggleLanguage: () => void;
}
const LocalizationContext = createContext<LocalizationContextType | undefined>(undefined);

interface LocalizationProviderProps {
    children: ReactNode;
}

// Provider Component
export const LocalizationProvider: React.FC<LocalizationProviderProps> = ({ children }: PropsWithChildren) => {
    const [language, setLanguage] = useState<string>(localStorage.getItem('lang') || 'ar');

    const toggleLanguage = () => {
        setLanguage((prevLang) => (prevLang === 'en' ? 'ar' : 'en'));
    };

    return <LocalizationContext.Provider value={{ language, toggleLanguage }}>{children}</LocalizationContext.Provider>;
};

// Custom Hook
export const useLocalization = (): LocalizationContextType => {
    const context = useContext(LocalizationContext);
    if (!context) {
        throw new Error('useLocalization must be used within a LocalizationProvider');
    }
    return context;
};
